import refinement from './refinement';
import serializeEventAttribute from 'cio/utils/conditions/serialize/event-attribute';
import FormEventAttributeCondition from 'cio/app-models/conditions/form-event-attribute';
import FormCondition from 'cio/app-models/conditions/form';
import { serializeFilters as serializeEventFilters } from './event';
import GroupCondition from 'cio/app-models/conditions/group';
import {
  SerializedLegacyAttributeFilterAnd,
  SerializedLegacyAttributeFilterOr,
  SerializedLegacyAttributeFilters,
} from 'cio/types/conditions/legacy-filter';
import { isGroupCondition } from 'cio/utils/conditions/serialize';

export function serializeFilters(
  filters: (FormEventAttributeCondition | GroupCondition | null)[],
  operator: 'or' | 'and',
  useComparisonOperator = false,
): SerializedLegacyAttributeFilters | Record<string, never> {
  // same serialization as for event attributes
  let serialized = filters.compact().map((f) => {
    if (isGroupCondition(f)) {
      return serializeFilters(
        f.children as (FormEventAttributeCondition | GroupCondition | null)[],
        f.operator,
        useComparisonOperator,
      );
    }

    return serializeEventAttribute(f as FormEventAttributeCondition, true, false, useComparisonOperator);
  });

  if (serialized.length === 0) {
    return {};
  }

  if (serialized.length === 1) {
    return serialized[0];
  }

  if (operator === 'or') {
    return {
      or: serialized,
    } as SerializedLegacyAttributeFilterOr;
  }
  return {
    and: serialized,
  } as SerializedLegacyAttributeFilterAnd;
}

export default function (obj: FormCondition) {
  let { name, inverse, filters, filterOperator, formFilter } = obj;
  let { times, within } = refinement(obj);

  let joinedFilters = {
    and: [serializeFilters([formFilter], 'and')],
  };

  if (filters?.length) {
    joinedFilters.and.push(serializeEventFilters(filters, filterOperator as 'or' | 'and'));
  }

  return {
    event: {
      type: 'event',
      ui_type: 'form',
      name,
      filters: joinedFilters,
    },
    times,
    within,
    inverse,
  };
}
